import { Component, OnInit, ChangeDetectorRef, OnChanges } from '@angular/core';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';
import { PriceModel } from 'src/app/model/stripe-models/product/price';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-tarife',
    templateUrl: './tarife.component.html',
    styleUrls: ['./tarife.component.scss'],
    standalone: false
})
export class TarifeComponent implements OnInit, OnChanges {
  public Packages: PackageModel[] = [];
  public ProductsToShow: PackageModel[] = [];
  public loading = true;
  private productsProcessed = 0;
  private totalProducts = 0;
  loggedIn = false;

  constructor(
    private dialogService: DialogService,
    private stripeService: StripeService,
    private cdr: ChangeDetectorRef,
    private userService: UserService,
    private route: ActivatedRoute,
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.userService.currentUserObservable.subscribe((user) => {
      if (user && this.userService.loggedIn) {
        this.loggedIn = this.userService.loggedIn;
      } else { this.loggedIn = false; }
    });
    await this.waitForProductsToBeAvailable();
  }

  async waitForProductsToBeAvailable(): Promise<void> {
    try {
      const productsObservable = await this.stripeService.getAllProducts();
      productsObservable.subscribe(
        async (data: any) => {
          if (!data || data.length === 0) {
            this.loading = false;
            return;
          };
          this.totalProducts = data.filter((item: any) => item.active).length;
          if (this.totalProducts === 0) {
            this.loading = false;
            return;
          };
          for (const item of data) {
            if (!item.active) { continue; }
            try {
              const pricesObservable = await this.stripeService.getPriceByProductID(item.id);
              pricesObservable.subscribe(async (productPrices: any) => {
                const yearlyPrices = productPrices.filter((price: any) =>
                  price.recurring && price.recurring.interval === 'year'
                );
                if (yearlyPrices.length === 0) {
                  this.stripeService.checkIfAllProductsProcessed();
                  return;
                }
                const productPrice = yearlyPrices[0];
                const priceRecurring = productPrice.recurring;
                const price: PriceModel = {
                  id: productPrice.id,
                  currency: productPrice.currency,
                  unit_amount: productPrice.unit_amount || productPrice.unitAmount,
                  recurring: {
                    interval: priceRecurring.interval,
                    interval_count: priceRecurring.interval_count || priceRecurring.intervalCount,
                    usage_type: priceRecurring.usage_type || priceRecurring.usageType
                  }
                };
                try {
                  const featuresObservable = await this.stripeService.getFeaturesByProductID(item.id);
                  featuresObservable.subscribe((productFeatures: any) => {
                    const packageColor = this.stripeService.getColorForPackage(item.name);
                    const packageModel: PackageModel = {
                      packageClass: item.name,
                      active: item.active,
                      images: item.images,
                      productId: item.id,
                      productDescription: item.description,
                      productName: item.name,
                      priceId: price,
                      unitAmount: price.unit_amount,
                      listItems: productFeatures || [],
                      color: packageColor,
                      title: item.metadata.title
                    };
                    if (packageModel.active) {
                      this.Packages.push(packageModel);
                      this.sortProductsToShow();

                      if (this.Packages.length === this.totalProducts) {
                        this.ProductsToShow = [...this.Packages];
                        this.handleShowDialog();
                      }
                      this.stripeService.updateProductsToShow();
                    }
                    this.loading = false;
                    this.cdr.detectChanges();
                    this.stripeService.checkIfAllProductsProcessed();
                  }, error => {
                    this.stripeService.checkIfAllProductsProcessed();
                  });
                } catch (error) {
                  this.stripeService.checkIfAllProductsProcessed();
                }
              }, error => {
                this.stripeService.checkIfAllProductsProcessed();
              });
            } catch (error) {
              this.stripeService.checkIfAllProductsProcessed();
            }
          }

          setTimeout(() => {
            if (this.loading) {
              this.loading = false;
            }
          }, 10000);


        }, error => {
          this.loading = false;
        }
      );
    } catch (error) {
      this.loading = false;
    }
  }

  ngOnChanges(): void {
    this.cdr.detectChanges();
  }

  private sortProductsToShow(): void {
    const desiredOrder = ['Starter', 'Professional', 'Enterprise'];
    this.Packages.sort((a, b) => {
      const indexA = desiredOrder.indexOf(a.productName || a.packageClass);
      const indexB = desiredOrder.indexOf(b.productName || b.packageClass);
      return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
    });
  }


  private handleShowDialog(): void {
    const showDialog = this.route.snapshot.queryParamMap.get('showDialog') === 'true';

    if (showDialog && this.ProductsToShow.length > 0) {
      this.dialogService.openTarifeSelectionDialog(
        "",
        "",
        this.ProductsToShow
      );
    }
  }

}
